import { Maybe } from '../../..';

export type EmailProps = { children: Maybe<string> };

export const Email = ({ children: email }: EmailProps) =>
  email ? (
    <a href={`mailto:${email}`} className="@Email text-primary hover:underline">
      {email}
    </a>
  ) : null;
